import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BooleanTypeProviderService } from './boolean-type-provider.service';
import { BooleanTypeSelectItems } from '../types/boolean-type-select-items';
import { BooleanType } from '../enums/boolean-type';
import { SelectItem } from '../../select-item/models/select-item';

@Injectable({
  providedIn: 'root',
})
export class BooleanTypeSelectItemsProviderService {
  private readonly provider = inject(BooleanTypeProviderService);

  public selectItems(): Observable<BooleanTypeSelectItems> {
    return this.provider
      .fetchAll()
      .pipe(
        map((items) =>
          items.map(
            ({ key, label }) => new SelectItem(label, key === BooleanType.TRUE),
          ),
        ),
      );
  }
}
